import { render, staticRenderFns } from "./SavedSearchesSidePanel.vue?vue&type=template&id=68b927ed&scoped=true&"
import script from "./SavedSearchesSidePanel.vue?vue&type=script&lang=ts&"
export * from "./SavedSearchesSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b927ed",
  null
  
)

export default component.exports